import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-quibbler-hp7-muggle-murders-rise",
  name: `The Quibbler\n'Muggle Murders Rise'`,
  nameFormatted: {
    primary: "The Quibbler",
    secondary: "'Muggle Murders Rise'",
  },
  origin: `Harry Potter and the Deathly Hallows`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
